import { required, email as emailRule, sameAs } from 'vuelidate/lib/validators'

export const userName = [
  {
    rule: required,
    msg: 'Name is required'
  }
]
export const name = [
  {
    rule: required,
    msg: 'Name is required'
  }
]
export const description = [
  {
    rule: required,
    msg: 'Description is required'
  }
]
export const firstName = [
  {
    rule: required,
    msg: 'First name is required'
  }
]
export const lastName = [
  {
    rule: required,
    msg: 'Last name is required'
  }
]

export const email = [
  {
    rule: required,
    msg: 'Email address is required'
  },
  {
    rule: emailRule,
    msg: 'Invalid email address'
  }
]

export const password = [
  {
    rule: required,
    msg: 'Password is required'
  }
  // {
  //   rule (value) {
  //     return value && value.length >= 4
  //   },
  //   msg: 'Password requires at least 4 characters'
  // }
]

export const confirmation = [
  {
    rule: required,
    msg: 'Confirmation is required'
  },
  {
    rule: sameAs('password'),
    msg: 'Password mismatch'
  }
]

export const userId = [
  {
    rule (value) {
      return !isNaN(Number(value))
    },
    msg: 'User ID must be a number'
  }
]

const vrules = (vdata) => {
  return vdata.reduce((acc, cur, i) => {
    acc[i] = cur.rule
    return acc
  }, {})
}

const vmsg = (validator, vdata) => {
  for (let i = 0; i < vdata.length; i++) {
    if (!validator[i]) { return vdata[i].msg }
  }
}

export default {
  vrules,
  vmsg
}



// WEBPACK FOOTER //
// ./src/helpers/validators.js